export default {
  id: "prizeList",
  initial: "loading",
  states: {
    loading: {
      entry: "setPrizeListRank",
      invoke: {
        id: "getPrizeList",
        src: "getPrizeList",
        onDone: {
          target: "success",
          actions: ["setPrizeList"]
        },
        onError: "failure"
      }
    },
    success: {
      entry: "getPrizeListSuccess"
    },
    failure: {
      entry: "getPrizeListFailure",
      meta: {
        ErrorMessage: "系统繁忙，请稍后再试！"
      },
      on: {
        RETRY: {
          target: "loading",
          actions: "retryPrizeList"
        }
      }
    }
  },
  on: {
    CLOSE: "#appActivity.participate"
  }
}
